import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import Login from '../pages/Login/Login';
import Home from '../pages/Home';
import Previlage from '../pages/Previlage/Overview'; 
import User from '../pages/Account/Overview'; 
import CheckContact from '../pages/CheckContact/Overview'; 
import AccessModules from '../pages/AccessModules/Overview';
import interactive from '../pages/interactive/Chat'; 
import CS from '../pages/HelpdeskCs/Overview'; 
import Spv from '../pages/Supervisor/Overview'; 
import Template from '../pages/Template/Overview'; 
import Category from '../pages/Category/Overview'; 
import Holiday from '../pages/Holiday/Overview';
import Priority from '../pages/Priority/Overview'; 
import Reply from '../pages/Reply/Overview'; 
import InvalidReply from '../pages/InvalidReply/Form'; 
import ChangePasssword from '../pages/UserLogin/ChangePasssword'; 
import KeyGroup from '../pages/Keygroup/Overview'; 
import ResetPasssword from '../pages/UserLogin/ResetPassword'; 
import ListUpload from '../pages/WAProfile/Overview'
import Personal from '../pages/WAProfile/Personal'
import PersonalMedia from '../pages/WAProfile/PersonalMedia'
import PersonalScheduleUpload from '../pages/WAProfile/PersonalScheduleUpload'
import SingleMedia from '../pages/WAProfile/SingleMedia'
import Scheduled from '../pages/WAProfile/Scheduled'
import UploadSingle from '../pages/WAProfile/UploadSingle'
import ReportBroadcast from '../pages/ReportBroadcast/Overview'
import TicketHistory from '../pages/Ticket/Overview'
import ReportInteractive from '../pages/ReportInteractive/Overview'
import ReportHelpdesk from '../pages/ReportHelpdesk/Overview'
import HsmTemplate from '../pages/HsmTemplate/Overview'
import WaProfileSetting from '../pages/WaProfileSetting/Form'
import RepliesCloseTicket from '../pages/RepliesCloseTicket/Overview';
import RegisterTemplate from '../pages/RegisterTemplate/Overview'
import FlowTemplate from '../pages/FlowTemplate/Overview'
import TemplateSender from '../pages/TemplateSender/Overview'
import TransmitterSetting from '../pages/TransmitterSetting/Overview'
import PushInteractive from '../pages/PushInteractive/Overview'
import DashboardPushSummary from '../pages/DashboardPushSummary/Overview'
import UploadMediaId from '../pages/UploadMediaId/Overview'
import Division from '../pages/Division/Overview'
import ReportButton from '../pages/ReportButton/Overview'
import ReportSession from '../pages/ReportSession/Dashboard'
import ReportSessionList from '../pages/ReportSession/OverView'
import QualityRating from '../pages/QualityRating/Overview'
import TemplateChecker from '../pages/TemplateChecker/Overview'
import BacklogClient from '../pages/BacklogClient/Overview'
import DashboardSmartMarketing from '../pages/DashboardSmartMarketing/Overview'

import ProtectedRoute from '../infra/routes/ProtectedRoutes'
import Chat from '../pages/Chat/Overview'
class AllRoutes extends Component {
    render() {
        return (
            <Switch>
                <ProtectedRoute exact path='/' component={Home} />
                <Route exact path='/Login' component={Login} />
                {/* <ProtectedRoute exact path='/Home' component={Home} allowedRoles={[]} /> */}
                <ProtectedRoute exact path='/Home' component={Home} />
                <ProtectedRoute exact path='/Privilage' component={Previlage} />
                <ProtectedRoute exact path='/CheckContact' component={CheckContact} />
                <ProtectedRoute exact path='/User' component={User} />
                <ProtectedRoute exact path='/Accessmodules' component={AccessModules} />
                <ProtectedRoute exact path='/cs' component={CS} />
                <ProtectedRoute exact path='/spv' component={Spv} />
                <ProtectedRoute exact path='/template' component={Template} />
                <ProtectedRoute exact path='/category' component={Category} />
                <ProtectedRoute exact path='/changepassword' component={ChangePasssword} />
                <ProtectedRoute exact path='/resetpassword' component={ResetPasssword} />
                <ProtectedRoute exact path='/inbox' component={Chat} />
                <ProtectedRoute exact path='/priority' component={Priority} />
                <ProtectedRoute exact path='/businesshour' component={Holiday} />
                <ProtectedRoute exact path='/RepliesCloseTicket' component={RepliesCloseTicket} />
                <ProtectedRoute exact path='/keygroup' component={KeyGroup} />
                <ProtectedRoute exact path='/Reply' component={Reply} />
                <ProtectedRoute exact path='/InvalidReply' component={InvalidReply} />
                <ProtectedRoute exact path='/ListUpload' component={ListUpload} />
                <ProtectedRoute exact path='/PersonalUpload' component={Personal} />
                <ProtectedRoute exact path='/PersonalUploadMedia' component={PersonalMedia} />
                <ProtectedRoute exact path='/SingleUpload' component={SingleMedia} />
                <ProtectedRoute exact path='/PersonalScheduleUpload' component={PersonalScheduleUpload} />
                <ProtectedRoute exact path='/Scheduled' component={Scheduled} />
                <ProtectedRoute exact path='/UploadSingle' component={UploadSingle} />
                <ProtectedRoute exact path='/TicketHistory' component={TicketHistory} />
                <ProtectedRoute exact path='/ReportBroadcast' component={ReportBroadcast} />
                <ProtectedRoute exact path='/ReportInteractive' component={ReportInteractive} />
                <ProtectedRoute exact path='/ReportHelpdesk' component={ReportHelpdesk} />
                <ProtectedRoute exact path='/ReportButton' component={ReportButton} />
                <ProtectedRoute exact path='/HsmTemplate' component={HsmTemplate} />
                <ProtectedRoute exact path='/RegisterTemplate' component={RegisterTemplate} />
                <ProtectedRoute exact path='/FlowTemplate' component={FlowTemplate} />
                <ProtectedRoute exact path='/templateSender' component={TemplateSender} />
                <ProtectedRoute exact path='/DashboardPushSummary' component={DashboardPushSummary} />
                <ProtectedRoute exact path='/PushInteractive' component={PushInteractive} />
                <ProtectedRoute exact path='/WaProfileSetting' component={WaProfileSetting} />
                <ProtectedRoute exact path='/templateSender' component={TemplateSender} />
                <ProtectedRoute exact path='/transmittersetting' component={TransmitterSetting} />
                <ProtectedRoute exact path='/backlogclient' component={BacklogClient} />
                <ProtectedRoute exact path='/DashboardPushSummary' component={DashboardPushSummary} />
                <ProtectedRoute exact path='/UploadMediaId' component={UploadMediaId} />
                <ProtectedRoute exact path='/division' component={Division} />
                <ProtectedRoute exact path='/c' component={interactive} />
                <ProtectedRoute exact path='/TicketHistory' component={TicketHistory} />
                <ProtectedRoute exact path='/WaProfileSetting' component={WaProfileSetting} />
                <ProtectedRoute exact path='/ReportSession' component={ReportSession} />
                <ProtectedRoute exact path='/ReportSessionList' component={ReportSessionList} />
                <ProtectedRoute exact path='/QualityRating' component={QualityRating} />
                <ProtectedRoute exact path='/TemplateChecker' component={TemplateChecker} />
                <ProtectedRoute exact path='/DashboardSmartMarketing' component={DashboardSmartMarketing} />
            </Switch>
        )
    }
}

export default (AllRoutes);
